import { useEffect, useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { BellRing, Check, CheckCheck, ListPlus, ExternalLink } from 'lucide-react';
import { cpdAPI, errMsg } from '../../lib/cpdRegisterAPI';
import { formatAUDate } from '../../lib/dateUtils';
import { toast } from 'sonner';
import { statusLabel, humanizeEnums } from './CPDStatus';

export const CPDAlertsTab = ({ me }) => {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState('open');
  const load = () => cpdAPI.alerts(status || undefined).then((r) => setItems(r.items)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, [status]);
  const op = async (id, o) => {
    try { const r = await cpdAPI.alertOp(id, o); if (o === 'task') toast.success('Task created', { description: 'Linked to this alert (one task per alert).' }); load(); return r; }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-3" data-testid="cpd-alerts-tab">
      <div className="flex gap-1 items-center">{['open', 'acknowledged', 'resolved', ''].map((s) => (
        <Button key={s || 'all'} size="sm" variant={status === s ? 'default' : 'outline'} className="rounded-full capitalize" onClick={() => setStatus(s)} data-testid={`cpd-alerts-filter-${s || 'all'}`}>{s ? statusLabel(s) : 'All'}</Button>))}
        {me.tier === 'admin' && <Button size="sm" variant="ghost" className="ml-auto" onClick={async () => { const r = await cpdAPI.runAlerts(); toast.success(`${r.created} new alert(s)`); load(); }} data-testid="cpd-alerts-run">Run check now</Button>}
      </div>
      {items.length === 0 && <p className="text-sm text-muted-foreground py-6 text-center">No alerts.</p>}
      {items.map((a) => (
        <Card key={a.id} data-testid={`cpd-alert-${a.id}`}><CardContent className="py-3 flex items-start gap-3">
          <BellRing className={`w-5 h-5 mt-0.5 ${a.status === 'open' ? 'text-amber-600' : 'text-slate-400'}`} />
          <div className="flex-1"><p className="font-medium text-sm">{a.title}</p><p className="text-sm text-muted-foreground">{humanizeEnums(a.body)}</p>
            <p className="text-xs text-muted-foreground mt-1">{a.user_name} · {formatAUDate(a.created_at)} · {statusLabel(a.status)}</p></div>
          {me.tier !== 'auditor' && <div className="flex gap-1 flex-wrap justify-end">
            {a.status === 'open' && <Button size="sm" variant="outline" onClick={() => op(a.id, 'acknowledge')} data-testid={`cpd-alert-ack-${a.id}`}><Check className="w-4 h-4 mr-1" />Acknowledge</Button>}
            {a.status !== 'resolved' && <Button size="sm" variant="outline" onClick={() => op(a.id, 'resolve')} data-testid={`cpd-alert-resolve-${a.id}`}><CheckCheck className="w-4 h-4 mr-1" />Resolve</Button>}
            {me.tier === 'admin' && (a.task_id ? <a href="/tasks" className="text-xs text-[#0055FF] inline-flex items-center gap-1 px-2" data-testid={`cpd-alert-task-link-${a.id}`}><ExternalLink className="w-3 h-3" />Task linked</a>
              : <Button size="sm" variant="ghost" onClick={() => op(a.id, 'task')} data-testid={`cpd-alert-task-${a.id}`}><ListPlus className="w-4 h-4 mr-1" />Create task</Button>)}
          </div>}
        </CardContent></Card>))}
    </div>
  );
};
